import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as DecrementIcon } from 'assets/icons/svgs/icon-decrement.svg';
import { ReactComponent as IncrementIcon } from 'assets/icons/svgs/icon-increment.svg';

export const InputNumber = (props) => {
  const {
    name,
    id,
    maxValue,
    operandDecrement = 1,
    operandIncrement = 1,
    decrementChangeHandler = () => {},
    incrementChangeHandler = () => {},
    disableIncrement,
    inputIsReadOnly,
    resetInputValue,
    defaultValue = 0,
    totalSeatsSelected,
    onChangeHandler = () => {},
  } = props;
  const [inputValue, setInputValue] = useState(defaultValue);

  useEffect(() => {
    setInputValue(defaultValue);
  }, [resetInputValue]);

  const handleDecrement = () => {
    if (inputValue > 0) {
      setInputValue((prevValue) => prevValue - operandDecrement);
      decrementChangeHandler(id, inputValue - operandDecrement, operandDecrement);
    }
  };

  const handleIncrement = () => {
    if (disableIncrement) {
      return;
    }

    const preventIncrement = totalSeatsSelected && totalSeatsSelected + operandIncrement > maxValue;

    if (
      !maxValue ||
      (totalSeatsSelected && !preventIncrement) ||
      (!totalSeatsSelected && inputValue < maxValue)
    ) {
      setInputValue((prevValue) => prevValue + operandIncrement);
      incrementChangeHandler(id, inputValue + operandIncrement, operandIncrement);
    }
  };

  const handleInputChange = (event) => {
    let val = parseInt(event.target.value, 10);

    // Prevent invalid and negative input value
    const preventInput = totalSeatsSelected && totalSeatsSelected + val > maxValue;
    if (Number.isNaN(val) || val > maxValue || preventInput) {
      setInputValue(0);
      onChangeHandler(id, 0);
    } else {
      val = val < 0 ? 0 : val;
      setInputValue(val);
      onChangeHandler(id, val);
    }
  };

  return (
    <div className="input-container input-number-container">
      <button
        type="button"
        className="value-decrease"
        data-testid="button-decrease"
        onClick={handleDecrement}
      >
        <span className="sr-only">Decrease value</span>
        <DecrementIcon />
      </button>
      <input
        id={id}
        name={name}
        type="text"
        className="form-control input-number"
        value={inputValue}
        readOnly={inputIsReadOnly}
        data-rule-number="true"
        data-testid={`input-value-${id}`}
        onChange={handleInputChange}
      />
      <button
        type="button"
        className="value-increase"
        data-testid="button-increase"
        onClick={handleIncrement}
      >
        <span className="sr-only">Increase value</span>
        <IncrementIcon />
      </button>
    </div>
  );
};

InputNumber.propTypes = {
  name: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxValue: PropTypes.number,
  operandDecrement: PropTypes.number,
  operandIncrement: PropTypes.number,
  decrementChangeHandler: PropTypes.func,
  incrementChangeHandler: PropTypes.func,
  disableIncrement: PropTypes.bool,
  inputIsReadOnly: PropTypes.bool,
  resetInputValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  defaultValue: PropTypes.number,
  totalSeatsSelected: PropTypes.number,
  onChangeHandler: PropTypes.func,
};
